import React, { useContext } from 'react'
import { PartsContext } from './App'

export default function Parts(props) {
  const { handlePartDelete, handlePartSelect } = useContext(PartsContext)
  const {
    id,
    nomenclature,
    stockNumber,
    location,
    reference
  } = props
  return (
    <div className="parts">
      <div className="parts__header">
        <h3 className="parts__title">{ nomenclature }</h3>
        <div>
          <button
            className="btn btn--primary mr-1"
            onClick={() => handlePartSelect(id)}
            >
            Edit
          </button>

          <button 
            className="btn btn--danger"
            onClick={() => handlePartDelete(id)}
          >
            &times;
          </button>
        </div>
      </div>
      <div className="parts__row">
        <span className="parts__label">Stock Number:</span>
        <span className="parts__value">{ stockNumber }</span>
      </div>
      <div className="parts__row">
        <span className="parts__label">Location:</span>
        <span className="parts__value">{ location }</span>
      </div>
      <div className="parts__row">
        <span className="parts__label">Reference:</span>
        <span className="parts__value">{ reference }</span>
      </div>
    </div>
  )
}